import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class CountryAdministrativeDivisionDescriptor extends Enum {
  static CA = {
    key: 40,
    get value() {
      return Lang.t('predefined.province-territory-or');
    }
  };

  static US = {
    key: 236,
    get value() {
      return Lang.t('predefined.state-district-territory');
    }
  };
}
